query CompaniesData($filter: CompanyFilter) {
  companies(filter: $filter, sort: { name: ASC }) {
    ...CompaniesListItem
  }
}

fragment CompaniesListItem on Company {
  id
  name
}
